import React, { useState } from 'react';
import { reduce, result, noop } from 'underscore';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { getRemainingCharsHintTextWithSchema } from './shared';
import { getRemainingCharsStyles } from './style';

export function withRemainingChars(WrappedComponent) {
  const RemainingCharsHOC = (props) => {
    const getNestedDataByPath = (data, path) => reduce(path.split('/'), (obj, seg) => result(obj, seg, {}), data);

    const [value, setValue] = useState(undefined);

    const onValidate = (validationResult) => {
      setValue(getNestedDataByPath(validationResult.data, props.validationProps.field));
      props.validationProps.onValidate(validationResult);
    };

    const classes = useDefaultStyles(getRemainingCharsStyles);

    const newValidationProps = {
      ...props.validationProps,
      onValidate,
    };

    return (
      <React.Fragment>
        <WrappedComponent {...props} validationProps={newValidationProps} />
        <div aria-live="polite" className={classnames('remaining-chars-container', classes.RemainingCharsContainer)} >
          { getRemainingCharsHintTextWithSchema(value, props.i18n, newValidationProps.schema, newValidationProps.field) }
        </div>
      </React.Fragment>
    );
  };

  RemainingCharsHOC.propTypes = {
    i18n: PropTypes.shape({}).isRequired,
    validationProps: PropTypes.shape({
      onValidate: PropTypes.func.isRequired,
      field: PropTypes.string.isRequired,
      schema: PropTypes.shape({}).isRequired,
    }),
  };

  RemainingCharsHOC.defaultProps = {
    validationProps: {
      onValidate: noop,
      field: undefined,
      schema: undefined,
    },
  };

  RemainingCharsHOC.displayName = `withRemainingChars(${getDisplayName(WrappedComponent)})`;
  hoistNonReactStatics(RemainingCharsHOC, WrappedComponent);

  return RemainingCharsHOC;
}
